export function valuesNonNull<T, K extends string | number>(
  p: Record<K, T | null>,
): p is Record<K, T> {
  const values = Object.values(p);
  return values.every((x) => x !== null);
}
export function nonNull<T>(p: T | null): p is T {
  return p !== null;
}
export function nonUndefined<T>(p: T | undefined): p is T {
  return p !== undefined;
}

export function isNull(p: any): p is null {
  return p === null;
}

export function allNonNull<T>(p: (T | null)[]): p is T[] {
  return p.every(nonNull);
}
